import { type ReactNode } from 'react';
import { LegalSectionView, type LegalSection } from './legal-section';
import { TERMS_BUSINESS } from './terms-data-business';
import { TERMS_RULES } from './terms-data-rules';
import { TERMS_FINAL } from './terms-data-final';

const SECTIONS: readonly LegalSection[] = [
  ...TERMS_BUSINESS,
  ...TERMS_RULES,
  ...TERMS_FINAL,
];

function Intro(): ReactNode {
  return (
    <p className="mb-lg text-xs leading-relaxed text-text-tertiary">
      Estos Términos rigen la participación en el programa &laquo;The 3333
      Games&raquo; gestionado por Debook. Para cualquier consulta, escribe a
      support@debook.app.
    </p>
  );
}

function Closing(): ReactNode {
  return (
    <p className="mt-lg text-xs italic leading-relaxed text-text-tertiary">
      Este documento constituye el contrato íntegro entre el usuario y La divina
      comedia sa. Al registrarse en la plataforma, usted confirma haber leído,
      comprendido y aceptado la totalidad de estas cláusulas.
    </p>
  );
}

export function TermsContent(): ReactNode {
  return (
    <div>
      <Intro />
      {SECTIONS.map((s) => (
        <LegalSectionView key={s.title} section={s} />
      ))}
      <Closing />
    </div>
  );
}
